import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Nav from '../components-public/Nav'
import Footer from '../components-public/Footer'
import { usePublicCase } from '../hooks/useCases'

export default function CaseDetailPage() {
  const { slug } = useParams()
  const { case: c, loading } = usePublicCase(slug)

  const seoTitle = c?.title || 'Case | Orken'
  const seoDesc = (c?.description || 'Conheça o case de sucesso da Orken Tecnologia.').slice(0, 160)

  const badgeLabel = c ? (c.sector === 'public' ? `Setor Público${c.sub_sector ? ` · ${c.sub_sector}` : ''}` : `Setor Privado${c.sub_sector ? ` · ${c.sub_sector}` : ''}`) : ''

  return (
    <>
      <Helmet>
        <title>{seoTitle} | Orken Tecnologia</title>
        <meta name="description" content={seoDesc} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDesc} />
        {c?.cover_image_url && <meta property="og:image" content={c.cover_image_url} />}
        <link rel="canonical" href={`https://orkentecnologia.com.br/cases/${slug}`} />
      </Helmet>
      <Nav />
      <main style={{ paddingTop: 104 }}>
        {loading && (
          <div className="section">
            <div className="section-inner" style={{ maxWidth: 800 }}>
              <div style={{ height: 18, width: '40%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 24 }} />
              <div style={{ height: 40, width: '80%', background: 'var(--bg-2)', borderRadius: 8, marginBottom: 12 }} />
              <div style={{ height: 16, width: '50%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 24 }} />
              <div style={{ height: 14, width: '100%', background: 'var(--bg-2)', borderRadius: 4, marginBottom: 8 }} />
              <div style={{ height: 14, width: '90%', background: 'var(--bg-2)', borderRadius: 4 }} />
            </div>
          </div>
        )}

        {c && (
          <section className="section">
            <div className="section-inner" style={{ maxWidth: 800 }}>
              <span className="case-sector-badge pub">{badgeLabel}</span>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 36, fontWeight: 800, color: 'var(--text)', marginBottom: 12, marginTop: 16 }}>{c.title}</h1>
              <p className="case-client" style={{ marginBottom: 24 }}>{c.client}</p>
              <p className="case-desc" style={{ fontSize: 16, lineHeight: 1.75 }}>{c.description}</p>
              <div className="case-result" style={{ marginTop: 32 }}>{c.featured_result}</div>
              {(c.tags || []).length > 0 && (
                <div className="case-tags" style={{ marginTop: 20 }}>
                  {c.tags.map(t => <span className="case-tag" key={t}>{t}</span>)}
                </div>
              )}
            </div>
          </section>
        )}

        {!loading && !c && (
          <div className="section">
            <div className="section-inner" style={{ maxWidth: 800, textAlign: 'center' }}>
              <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800, color: 'var(--text)', marginBottom: 16 }}>Case não encontrado</h1>
              <p style={{ color: 'var(--text-dim)' }}>O case que você buscou não existe ou ainda não foi publicado.</p>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  )
}
